import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class RouteGuard  {

  constructor(private _router : Router, private _cookieService : CookieService, private _activatedRoute: ActivatedRoute){}

  canActivate(
    route: ActivatedRouteSnapshot
  ){
      const isLoggedIn = this._cookieService.get('isLoggedIn');
      if(isLoggedIn === "true") {
        const orgCode = localStorage.getItem('organizationCode');
        if (!orgCode) {
          this.navToLogin();
          return false;
        }
        if(route.data && route.data.teamSelection) {
          return true;
        }
        let base = window.location.pathname.split('/')[1];
        if (base === "") {
          return true;
        }
        if (base === orgCode) {
          return true;
        } else {
          if(base) {
            const presentPage =  window.location.pathname.split('/')[2];
            let redirectUrl = this._router.serializeUrl(this._router.createUrlTree([`${orgCode}/dashboard`]));
            if(this._cookieService.get("super_admin")) {
              redirectUrl = this._router.serializeUrl(this._router.createUrlTree([`${orgCode}/organizations`]));
            }
            if(presentPage) {
                redirectUrl = this._router.serializeUrl(this._router.createUrlTree([`${orgCode}/${presentPage}`]));
            }
            window.open(redirectUrl, '_self');
            return true;
          }
          this._router.navigate(["not-found"]);
          return true;
        }
      }
      this.navToLogin();
      return false;
  }

  navToLogin() {
    localStorage.clear();
    let url = window.location.href;
    let domain = new URL(url).hostname;
    this._cookieService.delete('x-header-authToken', "/", domain);
    this._cookieService.delete('isLoggedIn', "/", domain);
    const loginUrl = this._router.serializeUrl(this._router.createUrlTree(['login']));
    window.open(loginUrl, '_self');
    let body = document.getElementsByTagName('body')[0];
    body.style.backgroundColor = '#F9FAFE';
  }

}
